import { useState } from "react";
import Cropper from "react-easy-crop";

export const ImageCropper = ({ aspectRatio, imageURL, onCropComplete }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  return (
    <Cropper
      image={imageURL}
      crop={crop}
      zoom={zoom}
      aspect={aspectRatio}
      objectFit="horizontal-cover"
      onZoomChange={setZoom}
      onCropChange={setCrop}
      onCropComplete={onCropComplete}
    />
  );
};
